import { useContext } from 'react';
import { Link } from 'react-router-dom';

import { GlobalContext } from '@contexts';
import { ChevronRightIcon } from '@svgs';

export const SiteBreadcrumbs = ({ children, siteData }) => {
  // base site breadcrumbs
  const globals = useContext(GlobalContext);
  // get website name
  const siteName =
    siteData?.locations?.length > 0 && siteData?.locations?.[0]?.location_name
      ? siteData.locations[0].location_name
      : siteData?.display_url;

  return (
    <div className="sb-main-breadcrumbs">
      <ul className="sb-flex">
        {globals.visible.projectsView && (
          <li className="sb-flex">
            <Link to={`/dashboard/projects`}>Projects</Link>
            <ChevronRightIcon />
          </li>
        )}
        <li className="sb-flex">
          {!siteData && <a>...</a>}
          {siteData && (
            <Link to={`/dashboard/projects/${siteData.business_id}`}>
              {siteData.business.business_name}
            </Link>
          )}
          <ChevronRightIcon />
        </li>
        <li className="sb-flex">
          {!siteData && <span>...</span>}
          {siteData && (
            <Link to={`/dashboard/sites/${siteData.id}`}>{siteName}</Link>
          )}
          <ChevronRightIcon />
        </li>
        {children}
      </ul>
    </div>
  );
};
